/**
 * An object containing properties for pagination events
 */
export class PaginationEvent {
  /**
   * The current page number
   */
  pageNumber?: number;

  /**
   * The initial page size to use
   */
  pageSize?: number;
}
